(function () {
  document.querySelectorAll('.oce-image-section').forEach(section => {
    const carousel = section.querySelector('.oce-image-carousel');
    if (!carousel || carousel.dataset.oceInitialized) return;
    carousel.dataset.oceInitialized = '1';

    const dashContainer = section.querySelector('.oce-carousel-dash-indicator');
    const originalSlides = [...carousel.querySelectorAll('.oce-image-slide')];
    const count = originalSlides.length;
    if (count < 2) return;

    carousel.append(originalSlides[0].cloneNode(true));
    carousel.prepend(originalSlides[count - 1].cloneNode(true));
    carousel.lastElementChild.classList.add('clone');
    carousel.firstElementChild.classList.add('clone');

    const slides = carousel.querySelectorAll('.oce-image-slide');
    let current = 0;
    let slideWidth = carousel.offsetWidth;
    const dashes = [];
    const fragment = document.createDocumentFragment();
    const dashIconHtml = '<img src="https://cdn.shopify.com/s/files/1/0868/2169/9918/files/DashO.svg" alt="Slide indicator" />';

    const updateDash = () =>
      dashes.forEach((dash, i) => dash.classList.toggle('active', i === current));

    const goTo = (idx, instant) => {
      current = idx;
      carousel.scrollTo({
        left: slideWidth * (idx + 1),
        behavior: instant ? 'auto' : 'smooth'
      });
      updateDash();
    };

    for (let i = 0; i < count; i++) {
      const dash = document.createElement('span');
      const navigate = () => goTo(i);

      dash.className = `oce-carousel-dash${i ? '' : ' active'}`;
      dash.innerHTML = dashIconHtml;
      dash.tabIndex = 0;
      dash.ariaLabel = `Bild ${i + 1}`;
      dash.addEventListener('click', navigate);
      dash.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') navigate();
      });

      dashes.push(dash);
      fragment.appendChild(dash);
    }

    dashContainer.innerHTML = '';
    dashContainer.appendChild(fragment);

    carousel.addEventListener('scroll', () => {
      const { scrollLeft } = carousel;

      if (scrollLeft <= 1) {
        carousel.scrollTo({ left: slideWidth * (slides.length - 2), behavior: 'auto' });
        current = slides.length - 3;
        return updateDash();
      }

      if (scrollLeft >= slideWidth * (slides.length - 1) - 1) {
        carousel.scrollTo({ left: slideWidth, behavior: 'auto' });
        current = 0;
        return updateDash();
      }

      const idx = Math.max(0, Math.min(count - 1, Math.round(scrollLeft / slideWidth) - 1));
      if (idx !== current) {
        current = idx;
        updateDash();
      }
    }, { passive: true });

    new ResizeObserver(() => {
      slideWidth = carousel.offsetWidth;
      goTo(current, true);
    }).observe(carousel);

    let isDown = false;
    let startX = 0;
    let startScrollLeft = 0;

    const stopDrag = () => {
      isDown = false;
      carousel.classList.remove('dragging');
    };

    carousel.addEventListener('mousedown', e => {
      isDown = true;
      carousel.classList.add('dragging');
      startX = e.pageX - carousel.offsetLeft;
      startScrollLeft = carousel.scrollLeft;
      e.preventDefault();
    });

    carousel.addEventListener('mouseleave', stopDrag);
    carousel.addEventListener('mouseup', stopDrag);

    carousel.addEventListener('mousemove', e => {
      if (!isDown) return;
      e.preventDefault();
      carousel.scrollLeft = startScrollLeft - (e.pageX - carousel.offsetLeft - startX);
    });

    requestAnimationFrame(() => {
      carousel.scrollTo({ left: slideWidth, behavior: 'auto' });
    });
  });
})();

